import * as ActionTypes from "../actions/types";
import _ from "lodash";
import gettingStartedData from "../data/gettingStartedStories.json";

// Normalize the data with field mapping
const normalizeStories = (stories, isLoggedIn = false) => {
  if (!Array.isArray(stories)) return [];

  return stories.map((story) => {
    const steps =
      story.steps?.map((step) => ({
        ...step,
        // Map target to targetId as used in the UI
        targetId: step.target,
        target: step.target, // Keep both for compatibility
      })) || [];

    return {
      ...story,
      steps,
      // If user is logged in, dynamically set disableForAnonymous to "0"
      disableForAnonymous: isLoggedIn ? "0" : story.disableForAnonymous,
    };
  });
};

// Initialize state with data from JSON
const normalizedData = normalizeStories(gettingStartedData);
const INITIAL_STATE = {
  gettingStartedById: _.mapKeys(normalizedData, "uuid"),
  gettingStartedAllIds: normalizedData.map((p) => p.uuid),
  errorMessage: undefined,
  loading: false,
};

function fetchGettingStarted(state, action) {
  // Re-normalize data based on current login status
  const isLoggedIn = action.payload?.isLoggedIn || false;
  const normalizedDataWithLogin = normalizeStories(
    gettingStartedData,
    isLoggedIn
  );

  // Update state with normalized data
  state.gettingStartedById = _.mapKeys(normalizedDataWithLogin, "uuid");
  state.gettingStartedAllIds = normalizedDataWithLogin.map((p) => p.uuid);
  state.loading = false;
}

function storeGettingStarted(state, action) {
  state.loading = false;
  state.gettingStartedById = _.mapKeys(action.payload, "uuid");
  state.gettingStartedAllIds = action.payload.map((p) => p.uuid);
}

export const gettingStarted = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.FETCH_GETTING_STARTED]: fetchGettingStarted,
    [ActionTypes.STORE_GETTING_STARTED]: storeGettingStarted,
  },
};
